import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "container",
        "template",
        "amount",
        "paymentTotal",
        "paymentTotalDisplay",
        "allocatedTotal",
        "remaining",
        "submitButton"
    ]

    connect() {
        this.recalculate()
    }

    recalculate() {
        const paymentTotal = parseFloat(this.paymentTotalTarget.value || 0)

        let allocated = 0

        this.amountTargets.forEach(input => {
            const value = parseFloat(input.value)
            if (!isNaN(value)) allocated += value
        })

        const remaining = paymentTotal - allocated

        this.paymentTotalDisplayTarget.textContent = paymentTotal.toFixed(2)
        this.allocatedTotalTarget.textContent = allocated.toFixed(2)
        this.remainingTarget.textContent = remaining.toFixed(2)

        this.remainingTarget.classList.toggle("fg-danger", remaining !== 0)
        this.remainingTarget.classList.toggle("fg-success", remaining === 0)

        this.valid()
    }

    valid() {
        const paymentTotal = parseFloat(this.paymentTotalTarget.value || 0)
        const remaining = parseFloat(this.remainingTarget.textContent || 0)
        const supplier = this.element.querySelector("[name='payment[supplier_id]']")
        const date = this.element.querySelector("[name='payment[payment_date]']")

        let valid = true

        if (!supplier || !supplier.value.trim()) valid = false
        if (!date || !date.value) valid = false
        if (isNaN(paymentTotal) || paymentTotal <= 0) valid = false
        if (Math.abs(remaining) > 0.01) valid = false
        if (this.amountTargets.length === 0) valid = false

        this.amountTargets.forEach(input => {
            const value = parseFloat(input.value)
            if (isNaN(value) || value <= 0) valid = false
        })

        const requiredFields = this.element.querySelectorAll("select[required], input[required]")

        requiredFields.forEach(field => {
            if (!field.value) valid = false
        })

        if (this.hasSubmitButtonTarget) {
            this.submitButtonTarget.disabled = !valid
        } else {
            this.element.dispatchEvent(
                new CustomEvent("form:state", {
                    bubbles: true,
                    detail: { valid }
                })
            )
        }

        return valid
    }

    removeLine(event) {
        event.preventDefault()

        const line = event.target.closest(".allocation-line")
        if (line) line.remove()

        this.recalculate()
    }

    addLine() {
        const index = Date.now()

        const content = this.templateTarget.innerHTML.replace(
            /NEW_RECORD/g,
            index
        )

        this.containerTarget.insertAdjacentHTML("beforeend", content)

        this.recalculate()
    }
}
